import { SETTINGS_APP_PLATFORM, ANALYTICS_APP_PLATFORM_WEB_APP } from "@anydo/core";
import Cookies from "js-cookie";

export function getReferral(): string {
  // Only web version can have referral
  if (
    SETTINGS_APP_PLATFORM !== ANALYTICS_APP_PLATFORM_WEB_APP ||
    typeof window === "undefined" ||
    typeof window.location === "undefined"
  ) {
    return "";
  }

  const searchParams = new URLSearchParams(window.location.search);

  /** @see https://anydo1.atlassian.net/browse/WEB4-269 */
  const gspk = searchParams.get("gspk");
  if (gspk) {
    return `PS_${gspk}`;
  }

  const referral = searchParams.get("referral");
  if (referral) return referral;

  const firstPromoter = Cookies.get("_fprom_tid");

  if (firstPromoter !== undefined) {
    return `FP_${firstPromoter}`;
  }

  return "";
}
